import { useState } from 'react';

const useTotal = ({ price, recurrence }) => {
  const [total, setTotal] = useState(0);

  const handleTotal = () => {
    const totalPrice = price * recurrence;
    setTotal(totalPrice);
  };

  return { total, setTotal, handleTotal };
};

export default useTotal;
